// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const blockText = "Security__blockText__rYkvv font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const blockTitle = "Security__blockTitle__9VL47 font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const bold = "700";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const partnerLogo = "Security__partnerLogo__Iy-Ig";
export const partnerLogos = "Security__partnerLogos__rvb9i";
export const regular = "400";
export const sans = "'sans'";
export const security = "Security__security__vIp1s";
export const semibold = "600";
export const serif = "'serif'";
export const summary = "Security__summary__ZRexQ";
export const summaryText = "Security__summaryText__uGS1a font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const summaryTitle = "Security__summaryTitle__qe0SZ font-faces__serifLight__iGPdI font-faces__serif__XseuP";